import { useReadLocalStorageBase } from '@/core/hooks'; // Used.
/**
 * Hook that allows to use *localStorage* for **Admin** application for read purposes.
 *
 * GOOD working solution, but it still has to specify generic explicitly.
 *
 * // TODO: check if it is still needed or not.
 *
 * @template T - The type of the state to be stored in local storage.
 * @param {AdminAppLocalStorageKey} key - The key under which the value is stored in local storage.
 * @param {?Partial<Options<T, true>>} [options] - Options for customizing the behavior of deserialization (optional).
 * @returns {T | null} - A stored value
 * @example
 * ```tsx
 * // Access the `count` value from storage.
 * const count = useAppReadLocalStorage<number>({ key:'count' });
 * ```
 */
export const useAppReadLocalStorage_NoInitialValue = ({ key, options }) => useReadLocalStorageBase(key, options);
// Overrides only needed to get `T` as return value, instead of `T | null` when initial`Value is specified
export function useAppReadLocalStorage({ key, initialValue, options }) {
    return useReadLocalStorageBase(key, initialValue, options);
}
